module.exports = __webpack_public_path__ + "img/marker-desa.ed0cafe6.svg";